//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

/* import { mapActions } from "vuex"; */

export default {
    name: "ViewAQHistory",
    components: {
        AQHistory,
        AQInput,
        AQModal,
        AQToggle,
        AQButton
    },
    data() {
        return {
            modalHistory: false,
            changeHistory: true,
            historyData: null,
            changeHistoryData: null
        };
    },
    computed: {
        typeHistory() {
            return this.changeHistory ? "change" : "save";
        },
        historyModalTitle() {
            return this.changeHistory ? this.$t("versioning.changeHModalTitle") : this.$t("versioning.saveHModalTitle");
        }
    },
    methods: {
        modalAction(evt) {
            console.log(evt);
            if (evt === "close") {
                this.modalHistory = false;
            }
        },
        menuClicked(evt) {
            alert(evt);
        },
        valueChanged() {
            this.changeHistoryData = this.historyData ? JSON.parse(this.historyData) : [];
            this.modalHistory = true;
        },
        resetValues() {
            this.historyData = "";
        }
    }
};
